import { Div, Flex, Grid } from "@hopper-ui/components";
import type { ReactNode } from "react";

interface InnerPageProps {
    content?: ReactNode;
    footer?: ReactNode;
}

export const InnerPage = ({ content, footer }: InnerPageProps) => {
    return (
        <Grid templateRows={["1fr", "auto"]} width="100%" height="100%">
            <Div overflow="auto" position="relative">
                <Div
                    UNSAFE_maxWidth="var(--wai-page-max-width)"
                    marginX="auto"
                >
                    {content}
                </Div>
            </Div>
            {footer &&
                <Flex padding="inset-md" borderTop="neutral-weak" justifyContent="end">
                    {footer}
                </Flex>
            }
        </Grid>
    );
};
